import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TypographyTextTag = styled(Typography)<{ opacity?: number, fontSize?: string | number, fontWeight?: number }>(({ theme, opacity, fontSize, fontWeight }) => ({
  fontSize: fontSize ?? "0.75rem",
  color: theme.customColors.textTag,
  opacity: opacity ?? 1,
  fontWeight: fontWeight ?? 600,
  fontStyle: "semibold"
}));
